import React, { useEffect, useState } from "react";
import DownloadIcon from "@mui/icons-material/Download";
import dayjs from "dayjs";
import CloseIcon from "@mui/icons-material/Close";
import {
  Grid,
  CardHeader,
  Card,
  CardActions,
  CardContent,
  Button,
  Typography,
  IconButton,
  Stack,
  Link,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogProps,
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Theme,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useNavigate, useParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { societyBillSeriesService } from "../../services/SocietyBillSeriesService";
import { societyBillsService } from "../../services/SocietyBillsService";
import { SocietyBillsModel } from "../../models/SocietyBillsModel";
import fileDownload from "js-file-download";
import { SelectListModel } from "../../models/ApiResponse";
import useForm from "../../utility/hooks/UseForm";
import Controls from "../../utility/controls/Controls";
import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
import EmailIcon from "@mui/icons-material/Email";
import SendIcon from "@mui/icons-material/Send";
import SmsIcon from "@mui/icons-material/Sms";
import { appInfoService } from "../../services/AppInfoService";
import { globalService } from "../../services/GlobalService";
import { societiesService } from "../../services/SocietiesService";
import { SocietiesModel } from "../../models/SocietiesModel";
import ConfirmDialog from "../helper/ConfirmDialog";
import { Messages, ROLES } from "../../utility/Config";
import { AuthContext } from "../../utility/context/AuthContext";
import { useSharedNavigation } from "../../utility/context/NavigationContext";
import { societySubscriptionsService } from "../../services/SocietySubscriptionsService";
import { Label } from "recharts";
import { SocietyBuildingTitleModel } from "../../models/SocietyBuildingsModel";
import { societyBuildingsService } from "../../services/SocietyBuildingsService";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    border: "0.5px solid grey",
    display: "inline-flex",
    width: "100% !important",
    margin: "0px !important",
  },
  item: {
    border: "0.5px solid grey",
    paddingTop: "2px !important",
  },
  footerCell: {
    // border: '0.5px solid grey',
    fontWeight: "bold !important",
  },
  footerCellAmount: {
    textAlign: "right", // without !important
    fontWeight: "bold", // without !important
    // If absolutely needed:
    "&.MuiTableCell-root": {
      textAlign: "right !important",
      fontWeight: "bold !important",
    },
  },
  tableHead: {
    backgroundColor: "lightgrey !important",
    fontWeight: "bold !important",
  },
}));

interface BillViewProps {
  open: boolean;
  onClose: () => void;
  SocietyId: string;
  SocietyBillId?: string;
  BillAbbreviation?: string;
  SocietySubscriptionId : string;
}

//const BillView = (...props: any) => {
const BillView: React.FC<BillViewProps> = ({
  open,
  onClose,
  SocietyId,
  SocietyBillId,
  BillAbbreviation,
  SocietySubscriptionId
}) => {
  globalService.pageTitle = "Bill";
  //const { societyBillId } = useParams();
  const [isReceiptVisible, setIsReceiptVisible] = useState(false);
  const [isReversalVisible, setIsReversalVisible] = useState(false);
  const [appInfo, setAppInfo] = React.useState(null);
  const [TaxApplicable, SetTaxApplicable] = React.useState(null);
  const [societyBill, setSocietyBill] = useState<any>(
    societyBillsService.initialFieldValues
  );
  const [maxWidth, setMaxWidth] = React.useState<DialogProps["maxWidth"]>("lg");
  let navigate = useNavigate();
  const { goToHome } = useSharedNavigation();
  //let societySubscriptionId = localStorage.getItem("societySubscriptionId");
  const [totWithGSTAmount, setTotWithGSTAmount] = useState<any>([]);
  const [totWithOutGSTAmount, setTotWithOutGSTAmount] = useState<any>();
  const [totalTaxNatureAmount, setTotalTaxNatureAmount] = useState(0);
  const [totalAllNatureAmount, setTotalAllNatureAmount] = useState(0);

  useEffect(() => {
    if (!globalService.isSocietySelected()) {
      globalService.info(Messages.SocietyUnSelected);
      return goToHome();
    }
    getAppInfo();
    getSocieties(SocietyId);
    if (SocietyBillId) {
      getBillDetailPopup();
    }
  }, [SocietyBillId]);

  const getAppInfo = () => {
    appInfoService.getAppInfo().then((response) => {
      let result = response.data;
      setAppInfo(result.row);
    });
  };

  const getSocieties = (SocietyId: any) => {
    societiesService.getById(SocietyId).then((response) => {
      if (response) {
        let result = response.data;
        SetTaxApplicable(result.data.TaxApplicable);
      }
    });
  };
  const downloadBillsReceiptsPDF = () => {
    let model = {
      SocietyId: SocietyId,
      SocietySubscriptionId: SocietySubscriptionId,
      SocietyBillId: SocietyBillId,
      BillAbbreviation: BillAbbreviation,
    };
    societyBillsService.createBillsReceiptsPdf(model).then((response) => {
      let result = response.data;
      fileDownload(result, "SocietyBillsReceipts.pdf");
    });
  };

  //let totLength = 0;
  //let WithGSTAmount = 0;
  let TotWithGSTAmount = 0;
  //let WithOutGSTAmount = 0;
  let TotWithOutGSTAmount = 0;

  //////////////////////////////////////

  const getBillDetailPopup = () => {
    societyBillsService
      .getViewSocietyBill(SocietyBillId, SocietySubscriptionId)
      .then((response) => {
        if (response) {
          let result = response.data;

          setSocietyBill(result.data);
          if (response.data.data.SocietyReceipts.length !== 0) {
            setIsReceiptVisible(true);
            //setIsReversalVisible(true);
          } else {
            setIsReceiptVisible(false);
          }
          if (response.data.data.SocietyCollectionReversals.length !== 0) {
            setIsReversalVisible(true);
          } else {
            setIsReversalVisible(false);
          }

          //totLength = response.data.data.spSocietyBillChargeHeads.length;
          //74, 2030
          if (response.data?.data?.spSocietyBillChargeHeads) {
            
            const chargeHeads = response.data.data.spSocietyBillChargeHeads;
            TotWithGSTAmount = chargeHeads
              .filter((x: any) => x.ChargeTax === true)
              .map((t: any) => t.Amount)
              .reduce((prev: any, next: any) => prev + next, 0);
            TotWithOutGSTAmount = chargeHeads
              .filter((x: any) => x.ChargeTax === false)
              .map((t: any) => t.Amount)
              .reduce((prev: any, next: any) => prev + next, 0);
            // for (var i = 0; i < totLength; i++) {
            //   if (response.data.data.spSocietyBillChargeHeads[i].ChargeTax === true) {
            //     WithGSTAmount = parseFloat(
            //       response.data.data.spSocietyBillChargeHeads[i].Amount
            //     );
            //     TotWithGSTAmount += WithGSTAmount
            //   }
            //   if (response.data.data.spSocietyBillChargeHeads[i].ChargeTax === false) {
            //     WithOutGSTAmount = parseFloat(
            //       response.data.data.spSocietyBillChargeHeads[i].Amount
            //     );
            //     TotWithOutGSTAmount += WithOutGSTAmount
            //   }
            // }
            const taxNatureTotal = chargeHeads
              .filter((x: any) => x.ChargeTax === true && x.Nature === "T")
              .map((t: any) => t.Amount)
              .reduce((prev: any, next: any) => prev + next, 0);

            //  Total of all Nature amounts
            const allNatureTotal = chargeHeads
              .filter((x: any) => x.ChargeTax === true && x.Nature !== "T")
              .map((t: any) => t.Amount)
              .reduce((prev: any, next: any) => prev + next, 0);

            setTotWithGSTAmount(TotWithGSTAmount);
            setTotWithOutGSTAmount(TotWithOutGSTAmount);
            setTotalTaxNatureAmount(taxNatureTotal);
            setTotalAllNatureAmount(allNatureTotal);
          }
        } else {
          setIsReceiptVisible(false);
          setIsReversalVisible(false);
        }
      });
  };

  const totalAmount =
    parseFloat(societyBill.UAmount) +
    (societyBill.Interest || 0) +
    (societyBill.TaxAmount || 0);

  //const terms = societyBill.SocietyBillSeries?.Terms;
  //const termsArray = terms ? terms.split("\n") : [];
  //const notes = societyBill.Note;
  //const noteArray = notes ? notes.split("\n") : [];
  const classes = useStyles();
  return (
    <>
      {" "}
      <div>
        <Dialog
          fullWidth={true}
          maxWidth={maxWidth}
          onClose={onClose}
          aria-labelledby="customized-dialog-title"
          open={open}
        >
          <DialogTitle id="customized-dialog-title">
            Society Bill & Receipt
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme: any) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent dividers>
            <>
              <Card sx={{ width: "100%" }}>
                <CardContent>
                  <React.Fragment>
                    <Box sx={{ width: "100%" }}>
                      <Grid
                        container
                        fontSize={14}
                        border={"1px solid rgba(224, 224, 224, 1)"}
                      >
                        <Grid item xs={12} sm={12} md={12} textAlign={"center"}>
                          <div
                            style={{
                              fontSize: "15px",
                              alignContent: "center",
                              fontWeight: "bold",
                            }}
                          >
                            {societyBill.Society?.Society}
                          </div>
                          <div
                            style={{ fontSize: "11px", alignContent: "center" }}
                          >
                            Regd. No. : {societyBill.Society?.RegistrationNo}{" "}
                            Dated :{" "}
                            {societyBill.Society?.RegistrationDate
                              ? dayjs(
                                  societyBill.Society?.RegistrationDate
                                ).format("DD-MMM-YYYY")
                              : ""}
                            ,
                          </div>
                          <div
                            style={{ fontSize: "13px", alignContent: "center" }}
                          >
                            {societyBill.Society?.Address},
                            {societyBill.Society?.City} -{" "}
                            {societyBill.Society?.Pin}
                          </div>
                          <div
                            style={{ fontSize: "13px", alignContent: "center" }}
                          >
                            {societyBill.Society?.TaxRegistrationNo == null
                              ? ""
                              : `GST No. : ${societyBill.Society?.TaxRegistrationNo}`}
                          </div>
                          <div
                            style={{ fontSize: "15px", alignContent: "center" }}
                          >
                            --
                            {appInfo?.FlagInfo?.GstBill === true &&
                            TaxApplicable === true ? (
                              <u>
                                <strong>
                                  {societyBill.SocietyBillSeries?.Note} Tax
                                  Invoice{" "}
                                </strong>
                              </u>
                            ) : (
                              <u>
                                <strong>
                                  {societyBill.SocietyBillSeries?.Note} B I L L{" "}
                                </strong>
                              </u>
                            )}
                          </div>
                        </Grid>
                      </Grid>
                      <Grid
                        container
                        fontSize={14}
                        border={"1px solid rgba(224, 224, 224, 1)"}
                      >
                        <Grid item xs={4} sm={4} md={4} paddingLeft={1}>
                          <strong>
                            Unit No:{" "}
                            {
                              societyBill.SocietyBuildingUnit?.SocietyBuilding
                                ?.Building
                            }
                            -{societyBill.SocietyBuildingUnit?.Unit}
                          </strong>
                          <br />
                          <strong>
                            Name: {societyBill.SocietyMember?.Member}
                          </strong>
                        </Grid>

                        <Grid
                          item
                          xs={4}
                          sm={4}
                          md={4}
                          textAlign={"center"}
                          style={{ whiteSpace: "pre-line" }}
                        >
                          <strong>
                            {societyBill.Particulars}
                            {/* {dayjs(societyBill.RegistrationDate).format( "DD-MMM-YYYY" )} */}
                          </strong>
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          sm={4}
                          md={4}
                          textAlign={"right"}
                          paddingRight={1}
                        >
                          <strong>
                            Bill No.: {societyBill.BillNo}
                            <br />
                            Bill Date:{" "}
                            {dayjs(societyBill.BillDate).format("DD-MMM-YYYY")}
                            <br />
                            Bill Due Date:{" "}
                            {dayjs(societyBill.DueDate).format("DD-MMM-YYYY")}
                          </strong>
                        </Grid>
                      </Grid>

                      <Table
                        className="tblReceipt"
                        sx={{
                          width: "100% !important",
                          border: "0.5 solid",
                          display: { xs: "block", md: "table" },
                          overflowX: "auto",
                          //whiteSpace: 'nowrap'
                        }}
                      >
                        {appInfo?.FlagInfo?.GstBill === true &&
                        TaxApplicable === true ? (
                          <TableBody>
                            <TableRow className={classes.tableHead}>
                              <TableCell size="small">
                                <strong>Nature Of Charges</strong>
                              </TableCell>
                              <TableCell size="small">
                                <strong>SAC Code</strong>
                              </TableCell>
                              <TableCell
                                size="small"
                                width={150}
                                className="muiTableCell-right"
                              >
                                <strong>Taxable Amount&nbsp;</strong>
                              </TableCell>
                              <TableCell
                                size="small"
                                width={150}
                                className="muiTableCell-right"
                              >
                                <strong>Non Taxable Amount</strong>
                              </TableCell>
                            </TableRow>
                            {societyBill.spSocietyBillChargeHeads?.map(
                              (item: any) => (
                                // {
                                //   item.Nature==="I" ||item.Nature==="T"&&(

                                //   )
                                // }
                                
                                
                                <TableRow key={item.ChargeHead}>
                                  <TableCell size="small">
                                    {item.ChargeHead}
                                     {item.ChargeTax}
                                  </TableCell>
                                  
                                  <TableCell size="small">
                                    {item.HSNCode}&nbsp;
                                  </TableCell>
                                  {item.ChargeTax === true ? (
                                    <TableCell
                                      size="small"
                                      className="muiTableCell-right"
                                    >
                                      {globalService.formatToIndianCurrency(
                                        item.Amount ?? 0
                                      )}
                                      &nbsp;
                                    </TableCell>
                                  ) : (
                                    <TableCell size="small"></TableCell>
                                  )}

                                  {item.ChargeTax === false ? (
                                    <TableCell
                                      size="small"
                                      className="muiTableCell-right"
                                    >
                                      {globalService.formatToIndianCurrency(
                                        item.Amount ?? 0
                                      )}
                                      &nbsp;
                                    </TableCell>
                                  ) : (
                                    <TableCell size="small"></TableCell>
                                  )}
                                </TableRow>
                              )
                            )}

                            {(totalTaxNatureAmount ?? 0) > 0 && (
                            <TableRow>
                              <TableCell
                                size="small"
                                className={classes.footerCell}
                              >
                                Tax Total
                              </TableCell>

                              <TableCell size="small"></TableCell>
                              <TableCell
                                size="small"
                                className={classes.footerCellAmount}
                              >
                                {globalService.formatToIndianCurrency(
                                  totalTaxNatureAmount ?? 0
                                )}
                              </TableCell>

                            </TableRow>
                            )}

                            {/* <TableRow>
                              <TableCell
                                size="small"
                                className={classes.footerCell}
                              >
                               Total Without Tax
                              </TableCell>

                              <TableCell size="small"></TableCell>
                              <TableCell
                                size="small"
                                className={classes.footerCellAmount}
                              >
                                {globalService.formatToIndianCurrency(
                                  totalAllNatureAmount ?? 0
                                )}
                              </TableCell>

                            </TableRow> */}

                            <TableRow>
                              <TableCell
                                size="small"
                                className={classes.footerCell}
                              >
                                Gross Amount
                              </TableCell>

                              <TableCell size="small"></TableCell>
                              <TableCell
                                size="small"
                                className={classes.footerCellAmount}
                              >
                                {globalService.formatToIndianCurrency(
                                  totWithGSTAmount ?? 0
                                )}
                              </TableCell>
                              <TableCell
                                size="small"
                                className={classes.footerCellAmount}
                              >
                                {globalService.formatToIndianCurrency(
                                  totWithOutGSTAmount ?? 0
                                )}
                              </TableCell>
                            </TableRow>
                            {societyBill.Arrears !== null &&
                              societyBill.Arrears !== 0 && (
                                <TableRow>
                                  <TableCell size="small">Arrears - Principal</TableCell>
                                  <TableCell size="small"></TableCell>
                                  <TableCell size="small"></TableCell>
                                  <TableCell
                                    size="small"
                                    className="muiTableCell-right"
                                  >
                                    <>
                                      {globalService.formatToIndianCurrency(
                                        societyBill.Arrears ?? 0
                                      )}
                                    </>
                                  </TableCell>
                                </TableRow>
                              )}
                            {societyBill.InterestArrears !== null &&
                              societyBill.InterestArrears !== 0 && (
                                <TableRow>
                                  <TableCell size="small">
                                     Arrears - Interest
                                  </TableCell>
                                  <TableCell size="small"></TableCell>
                                  <TableCell size="small"></TableCell>
                                  <TableCell
                                    size="small"
                                    className="muiTableCell-right"
                                  >
                                    <>
                                      {globalService.formatToIndianCurrency(
                                        societyBill.InterestArrears ?? 0
                                      )}
                                    </>
                                  </TableCell>
                                </TableRow>
                              )}
                            {societyBill.NonChgArrears !== null &&
                              societyBill.NonChgArrears !== 0 && (
                                <TableRow>
                                  <TableCell size="small">
                                    Additional Non Chargeable Arrears
                                  </TableCell>
                                  <TableCell size="small"></TableCell>
                                  <TableCell size="small"></TableCell>
                                  <TableCell
                                    size="small"
                                    className="muiTableCell-right"
                                  >
                                    <>
                                      {globalService.formatToIndianCurrency(
                                        societyBill.NonChgArrears ?? 0
                                      )}
                                    </>
                                  </TableCell>
                                </TableRow>
                              )}
                            {societyBill.TaxArrears !== null &&
                              societyBill.TaxArrears !== 0 && (
                                <TableRow>
                                  <TableCell size="small">
                                    Additional Tax Arrears
                                  </TableCell>
                                  <TableCell size="small"></TableCell>
                                  <TableCell size="small"></TableCell>
                                  <TableCell
                                    size="small"
                                    className="muiTableCell-right"
                                  >
                                    <>
                                      {globalService.formatToIndianCurrency(
                                        societyBill.TaxArrears ?? 0
                                      )}
                                    </>
                                  </TableCell>
                                </TableRow>
                              )}
                            {societyBill.Advance !== null &&
                              societyBill.Advance !== 0 && (
                                <TableRow>
                                  <TableCell size="small">
                                    Less Advance
                                  </TableCell>
                                  <TableCell size="small"></TableCell>
                                  <TableCell size="small"></TableCell>
                                  <TableCell
                                    size="small"
                                    className="muiTableCell-right"
                                  >
                                    <>
                                      {globalService.formatToIndianCurrency(
                                        societyBill.Advance ?? 0
                                      )}
                                    </>
                                  </TableCell>
                                </TableRow>
                              )}
                            <TableRow>
                              <TableCell
                                size="small"
                                className={classes.footerCell}
                              >
                                Net Amount Payable
                              </TableCell>
                              <TableCell></TableCell>
                              <TableCell size="small"></TableCell>
                              <TableCell
                                size="small"
                                className={classes.footerCellAmount}
                              >
                                {globalService.formatToIndianCurrency(
                                  societyBill.Payable ?? 0
                                )}
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        ) : (
                          // Ends TaxApplicable == true section
                          <TableBody>
                            {/* <TableRow>
                              <TableCell
                                size="small"
                                colSpan={2}
                                className={classes.tableHead}
                              >
                                Customer GST No :{" "}
                                {societyBill.SocietyMember?.GstNo ||
                                  "Not Available"}
                                &nbsp; &nbsp; &nbsp; &nbsp; Place Of Delivery :{" "}
                                {societyBill.Society?.State?.State}
                              </TableCell>
                            </TableRow> */}

                            <TableRow className={classes.tableHead}>
                              <TableCell size="small">
                                <strong>Nature Of Charges</strong>
                              </TableCell>
                              <TableCell size="small" width={150} className="muiTableCell-right">
                                <strong>Amount&nbsp;</strong>
                              </TableCell>
                            </TableRow>
                            {societyBill.spSocietyBillChargeHeads?.map(
                              (item: any) => (
                                <TableRow key={item.ChargeHead}>
                                  <TableCell size="small">
                                    {item.ChargeHead} {item.ChargeTax}
                                  </TableCell>
                                  <TableCell size="small" className="muiTableCell-right">
                                     {globalService.formatToIndianCurrency(
                                        item.Amount ?? 0
                                      )}&nbsp;
                                  </TableCell>
                                </TableRow>
                              )
                            )}
                            <TableRow>
                              <TableCell
                                size="small"
                                className={classes.footerCell}
                              >
                                Gross Amount
                              </TableCell>
                              <TableCell
                                size="small"
                                className={classes.footerCellAmount}
                              >
                                {globalService.formatToIndianCurrency(
                                  societyBill.UAmount +
                                    (societyBill.Interest ?? 0) +
                                    (societyBill.TaxAmount ?? 0) ?? 0
                                )}
                              </TableCell>
                            </TableRow>
                            {societyBill.Arrears !== null &&
                              societyBill.Arrears !== 0 && (
                                <TableRow>
                                  <TableCell size="small">Arrears</TableCell>
                                  <TableCell
                                    size="small"
                                    className="muiTableCell-right"
                                  >
                                    <>
                                      {globalService.formatToIndianCurrency(
                                        societyBill.Arrears ?? 0
                                      )}
                                    </>
                                  </TableCell>
                                </TableRow>
                              )}
                            {societyBill.InterestArrears !== null &&
                              societyBill.InterestArrears !== 0 && (
                                <TableRow>
                                  <TableCell size="small">
                                    Additional Interest Arrears
                                  </TableCell>
                                  <TableCell
                                    size="small"
                                    className="muiTableCell-right"
                                  >
                                    <>
                                      {globalService.formatToIndianCurrency(
                                        societyBill.InterestArrears ?? 0
                                      )}
                                    </>
                                  </TableCell>
                                </TableRow>
                              )}
                            {societyBill.NonChgArrears !== null &&
                              societyBill.NonChgArrears !== 0 && (
                                <TableRow>
                                  <TableCell size="small">
                                    Additional Non Chargeable Arrears
                                  </TableCell>
                                  <TableCell
                                    size="small"
                                    className="muiTableCell-right"
                                  >
                                    <>
                                      {globalService.formatToIndianCurrency(
                                        societyBill.NonChgArrears ?? 0
                                      )}
                                    </>
                                  </TableCell>
                                </TableRow>
                              )}
                            {societyBill.TaxArrears !== null &&
                              societyBill.TaxArrears !== 0 && (
                                <TableRow>
                                  <TableCell size="small">
                                    Additional Tax Arrears
                                  </TableCell>
                                  <TableCell
                                    size="small"
                                    className="muiTableCell-right"
                                  >
                                    <>
                                      {globalService.formatToIndianCurrency(
                                        societyBill.TaxArrears ?? 0
                                      )}
                                    </>
                                  </TableCell>
                                </TableRow>
                              )}
                            {societyBill.Advance !== null &&
                              societyBill.Advance !== 0 && (
                                <TableRow>
                                  <TableCell size="small">
                                    Less Advance
                                  </TableCell>
                                  <TableCell
                                    size="small"
                                    className="muiTableCell-right"
                                  >
                                    <>
                                      {globalService.formatToIndianCurrency(
                                        societyBill.Advance ?? 0
                                      )}
                                    </>
                                  </TableCell>
                                </TableRow>
                              )}
                            <TableRow>
                              <TableCell
                                size="small"
                                className={classes.footerCell}
                              >
                                Net Amount Payable
                              </TableCell>
                              <TableCell
                                size="small"
                                className={classes.footerCellAmount}
                              >
                                {globalService.formatToIndianCurrency(
                                  societyBill.Payable ?? 0
                                )}
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        )}
                      </Table>

                      <Typography>
                        <strong>IN WORDS :{societyBill.PayableString}</strong>
                      </Typography>
                      <Box style={{ whiteSpace: "pre-line" }}>
                        {societyBill.SocietyBillSeries?.Terms}
                        {/* {termsArray.map((data: any, index: any) => (
                     <Box key={index}>
                       <p>{data}</p>
                     </Box>
                   ))} */}
                      </Box>
                      <Typography align="right" marginTop={2} fontWeight={500}>
                        For {societyBill.Society?.Society.toUpperCase()}
                      </Typography>
                      <Typography>Checked By:</Typography>
                      <Typography align="right">
                        {societyBill.Society?.Signatory}
                      </Typography>
                    </Box>
                    {/* <Grid container spacing={2}>
                 <Grid item>
                   <Button
                     onClick={() => downloadPDF(societyBillId)}
                     variant="contained"
                     className="button"
                   >
                     Download PDF                                                                                                                                                                                                                                                                                                                                                                                                                                                                         
                   </Button>
                 </Grid>
               </Grid> */}
                  </React.Fragment>
                </CardContent>
              </Card>
              {(isReceiptVisible || isReversalVisible) && (
                <Card sx={{ width: "100%" }}>
                  <CardContent>
                    <React.Fragment>
                      <Box sx={{ width: "100%" }}>
                        <Typography
                          variant="h5"
                          component="legend"
                          textAlign={"center"}
                        >
                          Receipt
                        </Typography>
                        <Table sx={{ width: "100%" }}>
                          <TableBody>
                            <TableRow>
                              <TableCell sx={{ textAlign: "center" }}>
                                <div
                                  style={{
                                    fontSize: "15px",
                                    alignContent: "center",
                                  }}
                                >
                                  <strong>
                                    {societyBill.Society?.Society}
                                  </strong>
                                </div>
                                <div
                                  style={{
                                    fontSize: "11px",
                                    alignContent: "center",
                                  }}
                                >
                                  Regd. No. :{" "}
                                  {societyBill.Society?.RegistrationNo} Dated :{" "}
                                  {dayjs(
                                    societyBill.Society?.RegistrationDate
                                  ).format("DD-MMM-YYYY")}
                                  ,
                                  {societyBill.Society?.TaxRegistrationNo ==
                                  null
                                    ? ""
                                    : `GST No. : ${societyBill.Society?.TaxRegistrationNo}`}
                                </div>
                                <div
                                  style={{
                                    fontSize: "13px",
                                    alignContent: "center",
                                  }}
                                >
                                  {societyBill.Society?.Address},
                                  {societyBill.Society?.City} -{" "}
                                  {societyBill.Society?.Pin}
                                </div>
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                        <Table>
                          <TableHead className={classes.tableHead}>
                            <TableRow>
                              <TableCell size="small">Receipt No.</TableCell>
                              <TableCell size="small">Receipt Date</TableCell>
                              <TableCell size="small">Cheque No</TableCell>
                              <TableCell size="small">Dated</TableCell>
                              <TableCell size="small">Bank Name</TableCell>
                              <TableCell size="small">Amount</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {societyBill.SocietyReceipts?.map(
                              (item: any, index: any) => (
                                <TableRow key={index}>
                                  <TableCell size="small">
                                    {item.ReceiptNo}
                                  </TableCell>
                                  <TableCell size="small">
                                    {item.ReceiptDate
                                      ? dayjs(item.ReceiptDate).format(
                                          "DD-MMM-YYYY"
                                        )
                                      : ""}
                                  </TableCell>

                                  {item.SocietyPayModes ? (
                                    <>
                                      {item.SocietyPayModes.AskDetails ? (
                                        <>
                                          <TableCell size="small">
                                            {item.PayRefNo}
                                          </TableCell>
                                          <TableCell size="small">
                                            {item.PayRefDate
                                              ? dayjs(item.PayRefDate).format(
                                                  "DD-MMM-YYYY"
                                                )
                                              : ""}
                                          </TableCell>
                                          <TableCell size="small">
                                            {item.Bank ? item.Bank?.Bank : ""}{" "}
                                          </TableCell>
                                          <TableCell size="small">
                                            {item.Amount}
                                          </TableCell>
                                        </>
                                      ) : (
                                        <>
                                          <TableCell
                                            colSpan={3}
                                            size="small"
                                          ></TableCell>
                                          <TableCell size="small">
                                            {item.Amount}
                                          </TableCell>
                                        </>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      <TableCell
                                        colSpan={3}
                                        size="small"
                                      ></TableCell>
                                      <TableCell size="small">
                                        {item.Amount}
                                      </TableCell>
                                    </>
                                  )}
                                </TableRow>
                              )
                            )}
                            {isReversalVisible &&
                              societyBill.SocietyCollectionReversals?.map(
                                (item: any, index: any) => (
                                  <TableRow key={index}>
                                    <TableCell size="small">
                                      {item.DocNo}
                                    </TableCell>
                                    <TableCell size="small">
                                      {item.ReversalDate
                                        ? dayjs(item.ReversalDate).format(
                                            "DD-MMM-YYYY"
                                          )
                                        : ""}
                                    </TableCell>
                                    {item.SocietyPayModes ? (
                                      <>
                                        {item.SocietyPayModes.AskDetails ? (
                                          <>
                                            <TableCell size="small">
                                              {item.PayRefNo}
                                            </TableCell>
                                            <TableCell size="small">
                                              {item.PayRefDate
                                                ? dayjs(item.PayRefDate).format(
                                                    "DD-MMM-YYYY"
                                                  )
                                                : ""}
                                            </TableCell>
                                            <TableCell size="small">
                                              {item.Bank ? item.Bank?.Bank : ""}{" "}
                                            </TableCell>
                                            <TableCell size="small">
                                              {item.SocietyReceipt?.Amount * -1}
                                            </TableCell>
                                          </>
                                        ) : (
                                          <>
                                            <TableCell
                                              colSpan={3}
                                              size="small"
                                            ></TableCell>
                                            <TableCell size="small">
                                              {item.SocietyReceipt?.Amount * -1}
                                            </TableCell>
                                          </>
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        <TableCell
                                          colSpan={3}
                                          size="small"
                                        ></TableCell>
                                        <TableCell size="small">
                                          {item.SocietyReceipt?.Amount * -1}
                                        </TableCell>
                                      </>
                                    )}
                                  </TableRow>
                                )
                              )}
                          </TableBody>
                        </Table>
                        <Typography></Typography>
                        <Box style={{ whiteSpace: "pre-line" }}>
                          {societyBill.Note}
                          {/*  {noteArray.map((data: any, index: any) => (
                       <Box key={index}>
                         <p>{data}</p>
                       </Box>
                     ))} */}
                        </Box>
                        <Typography>
                          <strong>{societyBill.TotalAmountInWords}</strong>
                        </Typography>
                        <Typography
                          align="right"
                          marginTop={2}
                          fontWeight={500}
                        >
                          For {societyBill.Society?.Society.toUpperCase()}
                        </Typography>
                        <Typography>Checked By:</Typography>
                        <Typography align="right">
                          {societyBill.Society?.Signatory}
                        </Typography>
                      </Box>
                    </React.Fragment>
                  </CardContent>
                </Card>
              )}

              <CardActions sx={{ display: "flex", justifyContent: "center" }}>
                <Stack spacing={2} direction="row">
                  <Button
                    variant="contained"
                    color="error"
                    startIcon={<DownloadIcon />}
                    onClick={() => downloadBillsReceiptsPDF()}
                  >
                    PDF
                  </Button>
                </Stack>
              </CardActions>
            </>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
};
export default BillView;
